
import * as actionTypes from './actionTypes';

export const setWifiSecurityBand = (payload) => {
  return {
    type: actionTypes.SET_WIFI_SECURITY_BAND,
    payload
  }
};

export const setWifiSecurityLoading = () => ({
  type: actionTypes.WIFI_SECURITY_CHANGE_LOADING
});

export const setWifiSecuritySuccess = (payload) => ({
  type: actionTypes.SET_WIFI_SECURITY_SUCCESS,
  payload
});

export const setWifiSecurityFail = () => ({
  type: actionTypes.SET_WIFI_SECURITY_FAIL
});

export const getAllWifiSecuritySummary = () => ({
  type: actionTypes.GET_ALL_WIFI_SECURITY_SUMMARY
});

export const getAllWifiSecuritySummaryLoading = () => ({
  type: actionTypes.GET_ALL_WIFI_SECURITY_SUMMARY_LOADING,
});

export const getAllWifiSecuritySummarySuccess = (payload) => ({
  type: actionTypes.GET_ALL_WIFI_SECURITY_SUMMARY_SUCCESS,
  payload
});

export const getAllWifiSecuritySummaryFail = () => ({
  type: actionTypes.GET_ALL_WIFI_SECURITY_SUMMARY_FAIL
});








